"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "launchServerInBackground", {
    enumerable: true,
    get: function() {
        return launchServerInBackground;
    }
});
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _properlockfile = /*#__PURE__*/ _interop_require_default(require("proper-lockfile"));
const _execa = /*#__PURE__*/ _interop_require_default(require("execa"));
const _getBinPaths = require("../getBinPaths.js");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function launchServerInBackground({ logger, root, host, port, tasks, timeout, args, nodeArg }) {
    const lockfilePath = _path.default.join(root, `node_modules/.cache/lage/.lage-server-${host}-${port}.pid`);
    logger.info(`Starting server on http://${host}:${port}`);
    logger.info(`acquiring lock: ${lockfilePath}`);
    ensurePidFile(lockfilePath);
    const releaseLock = await _properlockfile.default.lock(lockfilePath, {
        stale: 1000 * 60 * 1,
        retries: {
            retries: 10,
            factor: 3,
            minTimeout: 0.5 * 1000,
            maxTimeout: 60 * 1000,
            randomize: true
        }
    });
    const pid = parseInt(_fs.default.readFileSync(lockfilePath, "utf-8"));
    const isServerRunning = pid && isAlive(pid);
    logger.info("Checking if server is already running", {
        pid,
        isServerRunning
    });
    if (pid && isServerRunning) {
        logger.info("Server already running", {
            pid
        });
    } else {
        const binScripts = (0, _getBinPaths.getBinScripts)();
        const lageServerBinPath = binScripts["lage-server"];
        const lageServerArgs = [
            ...nodeArg ? [
                "--node-arg",
                nodeArg
            ] : [],
            lageServerBinPath,
            "--tasks",
            ...tasks,
            "--server",
            `${host}:${port}`,
            "--timeout",
            `${timeout}`,
            ...args
        ];
        logger.info(`Launching lage-server with these parameters: ${lageServerArgs.join(" ")}`);
        const child = (0, _execa.default)("node", lageServerArgs, {
            cwd: root,
            detached: true,
            stdio: "ignore",
            maxBuffer: 1024 * 1024 * 100
        });
        if (child && child.pid) {
            _fs.default.writeFileSync(lockfilePath, child.pid.toString());
        }
        child.unref();
        logger.info("Server started", {
            pid: child.pid
        });
    }
    await releaseLock();
}
function ensurePidFile(lockfilePath) {
    if (!_fs.default.existsSync(_path.default.dirname(lockfilePath))) {
        _fs.default.mkdirSync(_path.default.dirname(lockfilePath), {
            recursive: true
        });
    }
    if (!_fs.default.existsSync(lockfilePath)) {
        try {
            const fd = _fs.default.openSync(lockfilePath, "w");
            _fs.default.closeSync(fd);
        } catch  {
        // ignore
        }
    }
}
function isAlive(pid) {
    try {
        return process.kill(pid, 0);
    } catch  {
        return false;
    }
}
